export default __webpack_public_path__ + "static/media/logotipoheader.02afdf2b.svg";